import { useLoadingStore } from '~/stores/loading'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('page:start', () => {
    const loadingStore = useLoadingStore()
    loadingStore.isLoading = true
    loadingStore.loadingText = 'Loading page...'
  })

  nuxtApp.hook('page:finish', () => {
    const loadingStore = useLoadingStore()
    loadingStore.isLoading = false
    loadingStore.loadingText = ''
    loadingStore.topLoadingText = null
  })

  nuxtApp.hook('app:error', () => {
    const loadingStore = useLoadingStore()
    loadingStore.isLoading = false
    loadingStore.loadingText = ''
    loadingStore.topLoadingText = null
  })
})
